import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import Button from "../elements/Button";
import SqMessage from '../flipToFibre/sqField/SqMessage';
import globals from '../globals';
import sqAnimations from './Nbn/sqAnimations';
import SqAddressList from './SqAddressList';
import DataSource from '../DataSource';
import { debounce } from 'lodash'

class SqField extends Component {

    constructor(props) {
        super(props);

        this.timeout = null

        this.state = {
            hasManualSearched: false,
            showResults: false,
            sq: globals.getSqFromSessionStorage(),
            address: globals.getSessionVar('address'),
            addressList: []
        }

        this.getAddresses = debounce(this.getAddresses.bind(this), 500)
        this.errorResults = [{ address: 'Oops! It appears something went wrong with your search.', value: false }]
    }

    componentDidMount() {
        if (Object.keys(this.state.sq).length > 0) {
            this.props.handleSqSubmit(this.ref);
            this.handleShowResults();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.response !== this.props.response) {
            this.setState({ sq: this.props.response }, () => {
                this.handleShowResults();
            })
        }
    }

	handleSubmitClick(event) {
		event.preventDefault();
        this.props.handleSqSubmit(this.ref);        
	}

    handleKeyDown(event) {
        if (event.keyCode === 13) {
            event.preventDefault();
            this.setState({ address: this.state.addressList[0].address }, () => {
                globals.setSessionVar('address', this.state.address)
                this.setState({ addressList: [] })
            })
            this.props.handleEnterPress(this.ref);
        }
        sqAnimations.hideMessage(this.ref);
        this.handleHideResults();
    }

    handleAddressClick(address, event) {
        event.preventDefault();
        this.setState({ address: address.address, addressList: [] })
        globals.setSessionVar('address', address.address)
        this.props.handleAddressClick(address, this.ref);
    }

    handleShowResults() {
        if (this.props.response.status !== '') {
            this.setState({ showResults: true });
        }
        
        return
    }
    
    handleHideResults() {
        this.setState({ showResults: false });
    }

    handleBlur() {
        setTimeout(() => {
            this.props.resetAddressList();
        }, 500);        
    }

    handleSetManualSearch() {
        this.setState({hasManualSearched: true});
    }

    handleResetManualSearch() {
        this.setState({hasManualSearched: false});        
    }

    handleChange (event) {
        this.getAddresses(event.currentTarget.value)
        this.setState({address: event.currentTarget.value})
    }

    getAddresses(address, source = 'footprint') {
        if (address.length > 4) {
            sqAnimations.showInlineLoader(this.ref);
            clearTimeout(this.timeout);

            const fullText = address
            DataSource.searchAddress({ fullText, source }, response => {
                sqAnimations.hideInlineLoader(this.ref);
                this.timeout = setTimeout(() => {
                    if (response.length > 0) {
                        const addressList = globals.processAddressesResponse(response)
                        this.setState({ addressList: addressList })
                        this.props.setAddressList(addressList)
                    } else {
                        DataSource.searchAddress({ fullText, source: 'api' }, response => {
                            if (response.length > 0) {
                                const addressList = globals.processAddressesResponse(response)
                                this.setState({ addressList: addressList })
                                this.props.setAddressList(addressList)
                            } else {
                                this.setState({
                                    addressList: [{ address: 'No address found.', value: false }]
                                });
                            }
                        })
                    }
                }, 500);
            })
        }
    }

    render() {        
        return (
            <div className="sq-field" id="sq-field" ref={el => this.ref = el}>
                <div className="inline-loader">
                    <img src="/images/loader-anim-inline.svg" alt="..." className="not-ie" />
                    <img src="/images/loader-anim-inline-ie.gif" alt="..." className="ie" style={{width: '60px'}} />
                </div>
                <input
                    type="text"
                    className="sq-input"
                    placeholder={(isMobile ? 'Enter your full address (including unit number)' : 'Enter your full address (including unit number)')}
                    value={this.state.address}
                    onChange={this.handleChange.bind(this)}
                    onKeyDown={this.handleKeyDown.bind(this)}
                />
                {!isMobile ? <button className={`btn do-wobble ${this.state.showResults ? 'open' : ''}`} onClick={event => this.handleSubmitClick(event)}>Search</button> : <Button
                    image={'/images/btn-search-mobile-white.svg'}
                    alt="Check address"
                    action={event => this.handleSubmitClick(event)}
                    newClass={`btn ${this.state.showResults ? 'open' : ''}`}
                    dontWobble="1"
                />}
                <div className="loader" style={{display: 'none'}}>
                    <img src={(isMobile ? '/images/loader-anim-mobile.svg' : '/images/loader-anim.svg')} alt="Loading..." className="not-ie" />
                    <img src="/images/loader-anim-ie.gif" alt="Loading..." className="ie" />
                </div>
				<progress id="contact-progress" value="0" max="100" className="not-ie" />
                <div className={`success ${this.state.showResults ? 'open' : ''}`}>
                    {this.state.showResults ? <a className="close-btn" onClick={this.handleHideResults.bind(this)}>
                        <img src="/images/icon-close-indigo.svg" />
                    </a> : <button className="do-wobble btn show-results" onClick={this.handleShowResults.bind(this)}>Show Results</button>}                    
                </div>
                <div className="message" style={{display: 'none'}}>
                    <div />
                </div>
                <SqAddressList
                    addressList={this.state.addressList}
                    response={this.props.response}
                    handleAddressClick={this.handleAddressClick.bind(this)}
                    handleBlur={this.handleBlur.bind(this)}
                    handleSearchAddress={this.handleAddressClick.bind(this)}
                    hasManualSearched={this.state.hasManualSearched}
                    handleSetManualSearch={this.handleSetManualSearch.bind(this)}
                    handleResetManualSearch={this.handleResetManualSearch.bind(this)}
                />
                {this.state.showResults ?
                    <SqMessage
                        address={this.props.address}
                        sqResult={this.state.sq}
                        hasError={this.props.hasError}
                        isOnFlipToFibre={this.props.isFlipToFibre}
                        handleHideResults={this.handleHideResults.bind(this)}
                    />
                    : ''}
            </div>
        );
    }
}

export default SqField;


// WEBPACK FOOTER //
// ./resources/assets/js/nbn/SqField.js